import { IonButton, IonCol, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonPage, IonRow, IonTitle, IonToolbar, useIonRouter, useIonToast } from '@ionic/react';
import './LogIn.css';
import getJsonFile from '../components/functions';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Redirect } from 'react-router';

const Account: React.FC = () => {
  const getAccessToken = () => Cookies.get('access_token')
  const getRefreshToken = () => Cookies.get('refresh_token')
  const isAuthenticated = () => !!getAccessToken()
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [present] = useIonToast();
  const router = useIonRouter();
var loading = 0;
  
  const handleReload = () => {
    window.location.reload();
  };

  async function getJsonFile(url: RequestInfo | URL, array: { id: any; }[] | any){

        //Agregar el timestamp a la URL para que no la cachée
        url = url + "?t=" + (new Date()).getTime();
    
        fetch(url).then(response => {
          return response.json();
        }).then(data => {
          Promise.all([data]).then(async function(data1){
            
          });
        }).catch(err => {
          // Do something for an error here
          console.log("Error Reading data " + err);
        });
    }


  const presentToast = (position: 'top' | 'middle' | 'bottom', msg: any) => {
    present({
      message: msg,
      duration: 1500,
      position: position
    });
  };

  async function sendDataToPHP() {
    const tokens = { accessToken: '', expires_in: 0 };
    const expires = (tokens.expires_in || 60 * 60) * 1000
    const inOneHour = new Date(new Date().getTime() + expires)

    // you will have the exact same setters in your Login page/app too
    Cookies.set('access_token', tokens.accessToken, { expires: inOneHour })
    Cookies.set('refresh_token', tokens.accessToken)
    presentToast('middle', 'LogOut Success')
    window.location.reload();
  }
  useEffect(() => {
    if(!isAuthenticated()){  
        router.push('/home', 'forward', 'push'); 
    }
  }, []);
    
    return (
        <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>MexFBA</IonTitle>
          </IonToolbar>
        </IonHeader>
        <div className='container1'>
          <IonRow>
            <IonButton color='danger' onClick={() => sendDataToPHP()}>Log Out</IonButton>
          </IonRow>
          <br></br>
        </div>
      </IonPage>
    );
  };
  
  export default Account;
